import krakenGif from '../../../assets/images/octopus-loading.gif';

export const InlineEditIcon = () => {
    return (
        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 50 50" xmlSpace="preserve">
            <g>
                <path d="M12.8,40.1c-0.8,0-1.5-0.3-2.1-0.9c-0.7-0.7-1-1.7-0.8-2.7l0.3-1.6c0.6-2.8,1.2-5.7,1.8-8.5c0.1-0.7,0.5-1.4,1-1.9l4.1-4.1l5.8-5.8c4.5-4.5,8.9-8.9,13.3-13.4c0.9-0.9,1.9-1.2,3-1.1h0.2c0.6,0.1,1.4,0.2,2.2,0.5c3.5,1.4,6,3.9,7.5,7.4c0.3,0.6,0.4,1.2,0.5,1.7l0.1,0.6c0,0.2,0.1,0.4,0,0.6c-0.1,1-0.5,1.9-1.2,2.6c-7.5,7.8-15.2,15.6-23,23.3c-0.6,0.6-1.2,0.9-2,1.1l-5.7,1.2L13.5,40C13.3,40.1,13.1,40.1,12.8,40.1z M39.1,4L26.4,16.7L21.1,22c-1.7,1.7-3.4,3.4-5.1,5.2l-1.5,7.2l-0.3,1.4l8.6-1.8l5.7-5.7l17.6-17.6v-0.2c-0.1-0.4-0.2-0.7-0.3-1c-1.1-2.5-2.9-4.3-5.4-5.3C40,4.1,39.5,4.1,39.1,4z M38.9,4C39,4,39,4,38.9,4z" />
                <path d="M37,49.8H4.7c-2.5,0-4.6-2.1-4.6-4.6V13c0-2.5,2.1-4.6,4.6-4.6h15.2c1.1,0,2,0.9,2,2s-0.9,2-2,2H4.7c-0.4,0-0.7,0.3-0.7,0.7v32.2C4,45.7,4.3,46,4.7,46H37c0.4,0,0.7-0.3,0.7-0.7V30.8c0-1.1,0.9-2,2-2s2,0.9,2,2v14.5C41.6,47.8,39.5,49.8,37,49.8z" />
            </g>
        </svg>
    );
};

export const InfoOutline = ({ height = '14px' }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" style={{ height: height }} viewBox="0 0 24 24">
            <path d="M11 9h2V7h-2m1 13c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8m0-18A10 10 0 0 0 2 12a10 10 0 0 0 10 10 10 10 0 0 0 10-10A10 10 0 0 0 12 2m-1 15h2v-6h-2v6z" />
        </svg>
    );
};

export const RemoveIcon = ({ width = 10, variant }: { width?: number, variant?: string }) => {
    return (
        <svg width={width} className={variant} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50">
            <path d="M31.4 25.2L47.8 8.8c1.8-1.8 1.8-4.7 0-6.4s-4.7-1.8-6.4 0L24.9 18.8 8.5 2.3C6.7.5 3.8.5 2 2.3S.3 7 2 8.8l16.4 16.4L2 41.6C.2 43.4.2 46.3 2 48c1.8 1.8 4.7 1.8 6.4 0l16.4-16.4L41.2 48c1.8 1.8 4.7 1.8 6.4 0 1.8-1.8 1.8-4.7 0-6.4L31.4 25.2z"></path>
        </svg>
    );
};

export const RefreshIcon = ({ width = 12, height = 12 }: { width?: number, height?: number }) => {

    return (
        <svg style={{ height: `${height}px`, width: `${width}` }} className="refresh-icon" role="presentation" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50">
            <path d="M27.4 49.5c9.9-1.1 17.8-9 19-18.9 1.5-12.9-8.6-24-21.2-24.1V.7c0-.3-.4-.5-.7-.3l-12 8.8c-.2.2-.2.4 0 .6l12 8.8c.3.2.7 0 .7-.3v-5.8c8.9.1 16 7.7 15.4 16.7-.5 7.8-6.8 14-14.6 14.5-8.2.5-15.2-5.3-16.5-13.1-.2-1.4-1.5-2.5-2.9-2.5-1.8 0-3.2 1.6-2.9 3.4 1.6 11.1 11.8 19.4 23.7 18z" />
        </svg>
    );
};

export const DeleteTrashcanIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" xmlSpace="preserve" style={{ height: "13px", marginTop: "4px", fillRule: "evenodd", clipRule: "evenodd", fill: "#e64c3c" }} id="Layer_1" x="0" y="0" version="1.1" viewBox="0 0 50 50"><path d="M45 7.1H34.3V4.5c0-.6-.1-1.2-.3-1.7-.2-.5-.6-1-1-1.5-.4-.4-.9-.7-1.5-1-.5-.2-1.1-.3-1.7-.3h-8.9c-.6 0-1.2.1-1.7.3-.5.2-1 .6-1.5 1-.4.4-.7.9-1 1.5-.2.5-.3 1.1-.3 1.7v2.7H5.7c-1 0-1.8.8-1.8 1.8s.8 1.8 1.8 1.8h1.9l2.1 34c.2 2.9 2.3 5.2 5.4 5.2h20.5c3 0 5.2-2.3 5.4-5.3l2.1-34H45c1 0 1.8-.8 1.8-1.8S46 7.1 45 7.1zM20 4.5c0-.1 0-.2.1-.3s.1-.2.2-.3c.1-.1.2-.1.3-.2.1 0 .2-.1.3-.1h8.9c.1 0 .2 0 .3.1s.2.1.3.2c.1.1.1.2.2.3 0 .1.1.2.1.3v2.7H20V4.5zm17.4 40c-.1 1.2-.9 1.9-1.8 1.9H15.1c-.9 0-1.7-.7-1.8-1.9l-2.1-33.8h28.3l-2.1 33.8z" className="st0" />
            <path d="M25.4 42.9c1 0 1.8-.8 1.8-1.8v-25c0-1-.8-1.8-1.8-1.8s-1.8.8-1.8 1.8v25c0 1 .8 1.8 1.8 1.8zm7 0c1 0 1.8-.7 1.8-1.7l.9-25c0-1-.7-1.8-1.7-1.8s-1.7.6-1.8 1.6l-.9 25c0 1 .8 1.8 1.7 1.9zm-14.1 0c1 0 1.8-.9 1.7-1.8l-.9-25c0-1-.9-1.8-1.8-1.7s-1.8.9-1.7 1.8l.9 25c0 .9.8 1.7 1.8 1.7z" className="st0" />
        </svg>
    );
};

export const FolderRightArrowIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M20 18H4V8h16v10M12 6l-2-2H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16c1.11 0 2-.89 2-2V8a2 2 0 0 0-2-2h-8m-1 8v-2h4V9l4 4-4 4v-3h-4z" /></svg>
    );
};

export const CheckmarkCircleIcon = ({ height = 14, fill = '#00b200', variant }: { height?: number, fill?: string, variant?: string }) => {
    return (
        <svg style={{ height: height, fill: fill }} className={variant} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50">
            <path d="M25 49.5c-6.5 0-12.7-2.5-17.3-7.2C3 37.7.5 31.5.5 25S3 12.3 7.7 7.7C12.3 3 18.5.5 25 .5S37.7 3 42.3 7.7c4.6 4.6 7.2 10.8 7.2 17.3S47 37.7 42.3 42.3 31.5 49.5 25 49.5zm0-45.2C13.6 4.3 4.3 13.6 4.3 25S13.6 45.7 25 45.7 45.7 36.4 45.7 25 36.4 4.3 25 4.3z" />
            <path d="M22.1 33.6c-.5 0-1-.2-1.3-.6l-7.5-7.5c-.7-.7-.7-2 0-2.7.7-.7 2-.7 2.7 0l6.2 6.2 12.1-12.1c.7-.7 2-.7 2.7 0 .4.4.6.8.6 1.3s-.2 1-.6 1.3L23.4 33.1c-.4.3-.8.5-1.3.5z" />
        </svg>
    );
};

export const EmptyCircleIcon = ({ height = 14, fill = '#00aeef', variant }: { height?: number, fill?: string, variant?: string }) => {
    return (
        <svg version="1.1" style={{ height: height, fill: fill }} className={variant} xmlns="http://www.w3.org/2000/svg" x="0" y="0" viewBox="0 0 50 50" xmlSpace="preserve">
            <path d="M25 49.5c-6.5 0-12.7-2.5-17.3-7.2C3 37.7.5 31.5.5 25S3 12.3 7.7 7.7C12.3 3 18.5.5 25 .5S37.7 3 42.3 7.7c4.6 4.6 7.2 10.8 7.2 17.3S47 37.7 42.3 42.3 31.5 49.5 25 49.5zm0-45.2C13.6 4.3 4.3 13.6 4.3 25S13.6 45.7 25 45.7 45.7 36.4 45.7 25 36.4 4.3 25 4.3z"></path>
        </svg>
    );
};

export const DropdownArrowDown = ({ height = 9, width = 9, fillColor = '#737576' }: { height?: number, width?: number, fillColor?: string }) => {
    return (
        <svg style={{ height: `${height}`, width: `${width}` }} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50">
            <path fill={fillColor} d="M22.5 37.4L1 15.9C-.4 14.5-.4 12.3 1 11s3.6-1.4 5 0l19 19 19-19c1.4-1.4 3.6-1.4 5 0s1.4 3.6 0 4.9L27.5 37.4c-.7.7-1.6 1-2.5 1s-1.8-.3-2.5-1z" />
        </svg>
    );
};

export const ClockIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" style={{ opacity: "0.5" }} viewBox="0 0 16 16" xmlSpace="preserve">
            <path d="M8 15.5C3.9 15.5.5 12.1.5 8S3.9.5 8 .5s7.5 3.4 7.5 7.5-3.4 7.5-7.5 7.5zM8 1.8C4.6 1.8 1.8 4.6 1.8 8c0 3.4 2.8 6.2 6.2 6.2 3.4 0 6.2-2.8 6.2-6.2 0-3.4-2.8-6.2-6.2-6.2z" />
            <path d="M11.1 11.8c-.2 0-.3-.1-.5-.2L7.5 8.7c-.1-.1-.1-.3-.1-.4V4c0-.3.3-.6.6-.6.4 0 .6.3.6.6v4l3 2.7c.1.1.2.3.2.4 0 .2-.1.3-.2.4-.1.2-.3.3-.5.3z" />
        </svg>
    );
};

export const LoaderIcon = ({ spinnerColor = '#fff' }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" xmlSpace="preserve" width="20" height="20" version="1.0" viewBox="0 0 128 128">
            <g>
                <circle cx="16" cy="64" r="16" fill={spinnerColor} />
                <circle cx="16" cy="64" r="16" fill={spinnerColor} fillOpacity=".67" transform="rotate(45 64 64)" />
                <circle cx="16" cy="64" r="16" fill={spinnerColor} fillOpacity=".42" transform="rotate(90 64 64)" />
                <circle cx="16" cy="64" r="16" fill={spinnerColor} fillOpacity=".2" transform="rotate(135 64 64)" />
                <circle cx="16" cy="64" r="16" fill={spinnerColor} fillOpacity=".12" transform="rotate(180 64 64)" />
                <circle cx="16" cy="64" r="16" fill={spinnerColor} fillOpacity=".12" transform="rotate(225 64 64)" />
                <circle cx="16" cy="64" r="16" fill={spinnerColor} fillOpacity=".12" transform="rotate(270 64 64)" />
                <circle cx="16" cy="64" r="16" fill={spinnerColor} fillOpacity=".12" transform="rotate(315 64 64)" />
                <animateTransform attributeName="transform" calcMode="discrete" dur="720ms" repeatCount="indefinite" type="rotate" values="0 64 64;315 64 64;270 64 64;225 64 64;180 64 64;135 64 64;90 64 64;45 64 64" />
            </g>
        </svg>
    );
};

export const PlusIcon = () => {
    return (
        <svg style={{ width: '10px' }} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50"><path d="M25 50c-2.9 0-5.2-2.3-5.2-5.2V30.2H5.2C2.3 30.2 0 27.9 0 25s2.3-5.2 5.2-5.2h14.7V5.2C19.9 2.3 22.2 0 25 0c2.9 0 5.2 2.3 5.2 5.2v14.7h14.6c2.9 0 5.2 2.3 5.2 5.2s-2.3 5.2-5.2 5.2H30.2L30.1 45c0 2.7-2.3 5-5.1 5z" /></svg>
    );
};

export const LeftArrow = () => {
    return (
        <svg role="presentation" width="14" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 65 50"><path d="M61.1 21.7H11.8L27.5 6.1c1.4-1.4 1.3-3.6 0-5s-3.5-1.4-4.9 0L1.3 22.5c-.7.7-1 1.6-1 2.5s.3 1.8 1 2.5l21.3 21.3c1.3 1.4 3.5 1.4 4.9 0 1.4-1.4 1.4-3.6 0-5L12.3 28.6h48.8c1.9 0 3.4-1.5 3.4-3.4s-1.5-3.5-3.4-3.5z"></path></svg>
    );
};

export const DownloadArrow = () => {
    return (
        <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50"><path className="st0" d="M49.9 27.3V40c0 5.2-4.2 9.5-9.5 9.5H9.7C4.5 49.5.2 45.3.2 40V26.9c0-1 .8-1.8 1.8-1.8s1.8.8 1.8 1.8V40c0 3.2 2.6 5.8 5.8 5.8h30.8c3.2 0 5.8-2.6 5.8-5.8V27.1c0-1 .8-1.8 1.8-1.8 1.1 0 1.9 1 1.9 2z" /><path className="st0" d="M26.2 38.1l11.5-11.7c.8-.8.8-1.8 0-2.6s-1.8-.8-2.6 0l-8.4 8.4V2.5c0-1-.8-1.8-1.8-1.8s-1.8.8-1.8 1.8v30L14.5 24c-.8-.8-1.8-.8-2.6 0-.4.4-.6.8-.6 1.2 0 .4.2 1 .6 1.2l11.5 11.5c1 .8 2 .8 2.8.2z" /></svg>
    );
};

export const CopyPage = ({ height = 12 }: { height?: number }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" style={{ height: `${height}px` }}>
            <path d="M35.8.3H17.2c-3.3 0-6.2 3-6.2 6.2H9.2c-3.3 0-5.9 3-5.9 6.1v30.9c0 3.2 2.9 6.2 6.2 6.2h23.2c3.3 0 6.2-3 6.2-6.2h1.5c3.3 0 6.2-3 6.2-6.2V12.7L35.8.3zm-3.1 46.4H9.5c-1.6 0-3.1-1.5-3.1-3.1v-31c0-2.3 1.9-3.1 4.6-3.1v27.8c0 3.2 2.9 6.2 6.2 6.2h18.6c0 1.9-1.2 3.2-3.1 3.2zm3.1-13.9H21.9c-.9 0-1.5-.7-1.5-1.5 0-.9.7-1.5 1.5-1.5h13.9c.9 0 1.5.7 1.5 1.5.1.8-.6 1.5-1.5 1.5zm0-7.8H21.9c-.9 0-1.5-.7-1.5-1.5 0-.9.7-1.5 1.5-1.5h13.9c.9 0 1.5.7 1.5 1.5.1.8-.6 1.5-1.5 1.5zm3.1-12.4c-1.6 0-3.1-1.5-3.1-3.1V3.4l7.7 9.2h-4.6z" />
        </svg>
    );
};

export const KrakenGif = ({ height = 12 }: { height?: number }) => {
    return (
        <img style={{ height: height }} src={krakenGif}></img>
    );
};

export const AiFileType = ({ height = 22 }: { height?: number }) => {
    return (
        <svg style={{height}} version="1.1" viewBox="0 0 512 512" xmlSpace="preserve" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
            <g id="_x31_1_x2C__Illustrator_x2C__Adobe_x2C__Ai">
                <g>
                    <rect height="510.578" style={{fill:'#F0A024',width: "510.576"}} x="1.207" y="0.711"/>
                    <rect height="465.646" style={{ fill:'#373122', width:'465.646'}} x="23.669" y="23.179"/>
                <g>
            <g>
            <g id="XMLID_335_">
                <g id="XMLID_341_">
                    <g>
                        <path d="M177.76,291.347l-18.431,61.119c-0.303,2.109-1.21,2.813-3.021,2.813h-30.82         c-2.113,0-2.714-1.057-2.113-3.511c16.317-53.748,43.809-143.321,63.144-204.092c0.908-3.511,1.815-7.025,2.417-19.32         c0-1.403,0.908-2.107,1.815-2.107h41.696c1.508,0,1.811,0.352,2.416,1.756c22.354,72.011,46.827,151.4,69.788,224.113         c0.605,2.104,0,3.161-1.811,3.161h-33.841c-1.511,0-2.115-0.703-2.716-2.108l-19.339-61.823H177.76z M238.787,256.92         c-6.043-23.535-20.848-70.956-26.887-95.545h-0.303c-4.535,23.183-16.918,62.877-25.983,95.545H238.787z" id="XMLID_342_" style={{fill:'#F0A024'}}/>
                    </g>
                </g>
                <g id="XMLID_337_">
                    <g>
                        <path d="M335.278,139.531c0-12.996,8.607-21.776,20.183-21.776         c12.172,0,19.595,8.78,19.595,21.776c0,13.35-8.016,21.78-19.889,21.78C343.29,161.311,335.278,152.881,335.278,139.531z          M337.354,187.304c0-2.107,0.592-2.808,2.08-2.808h31.463c1.782,0,2.379,0.351,2.379,2.808v165.098         c0,1.76-0.597,2.808-2.379,2.808h-30.871c-1.78,0-2.672-0.698-2.672-3.157V187.304z" id="XMLID_338_" style={{fill:'#F0A024'}}/>
                    </g>
                </g>
            </g></g></g></g></g>
            <g id="Layer_1"/>
        </svg>
    );
};